import id from './{id}';
import query from './query';
import get from './get';
import post from './post';

export type PostPayload = {
  defaultSchedule: string;
  name: string;
  reactions: number[];
};
export default { id, query, get, post };
